import { render } from "./RoleList.vue?vue&type=template&id=4cf2bebf&scoped=true"
import script from "./RoleList.vue?vue&type=script&lang=js"
export * from "./RoleList.vue?vue&type=script&lang=js"

import "./RoleList.vue?vue&type=style&index=0&id=4cf2bebf&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf2bebf"]])

export default __exports__